<template>
    <div class="home-videos">
        <div style="width: 97%;margin: auto">
            <van-cell title="企业视频区" value="更多" is-link style="background-color: #dddddd"/>
        </div>
        <div style="width: 97%;margin: auto;padding: 0px 8px">
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                phone: '',
                url: 'https://v.youku.com/v_show/id_XNjExMzk0MDg2OA==.html?spm=a2hja.14919748_WEBHOME_NEW.drawer2.d_zj1_2&s=ebfdfe59c76b49fb9fbe&scm=20140719.rcmd.35027.show_ebfdfe59c76b49fb9fbe'
            };
        },
        async created() {
            this.deptId = getDeptId()
            this.getCats()
        },
        methods: {
            async getCats() {
                let data = {
                    deptId: this.deptId,
                    catType: 0,
                }
                let res = await this.$get("/spm/getSpmCats", data)
                this.cats = res.list
            },
        },
    };
</script>

<style lang="scss" scoped>
    .home-videos {
        height: 100%;
        margin-top: 15px;
        margin-bottom: 10px;
    }

    .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 5px 8px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
    }

</style>
